import dynamic from 'next/dynamic'
import { BlockProps } from '../BlockProps'
import { ITextImageSplitBlockData } from './ITextImageSplitBlockData'

export const DynamicTextImageSplitBlock = dynamic<
  BlockProps<ITextImageSplitBlockData>
>(() => import('./TextImageSplitBlock').then((md) => md.TextImageSplitBlock))
